import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

import { TranslatedActionTypes } from '@models/action';
import { EITransactionInstanceModel } from '@models/module/entityInstance';
import { ModuleInstanceService } from '@module-instance/services';
import { ActivityRequestParams } from './activity.model';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  private translate = inject(TranslateService);
  private moduleInstanceService = inject(ModuleInstanceService);

  getActivityList({ moduleId, entityInstanceId, contractId }: Partial<ActivityRequestParams>) {
    return this.moduleInstanceService.getActivityEntityInstance({ moduleId, entityInstanceId, contractId }).pipe(
      map(({ actionInstances }) =>
        actionInstances.map(action => ({
          ...action,
          actionName: this.getActionName(action),
          /* For some reason, it comes '0' from BE */
          entityInstanceId,
        })),
      ),
    );
  }

  getActivityItem({ moduleId, actionInstanceId, contractId, noFields }: Partial<ActivityRequestParams>) {
    return this.moduleInstanceService
      .getTransitionInstanceInformations({
        moduleId,
        actionInstanceId,
        contractId,
        noFields,
      })
      .pipe(
        map(activity => {
          // Setting the height of each field to 1 row, to avoid empty spaces. The field's height already grows if needed.
          activity.fields?.forEach(field => (field.rows = 1));
          return activity;
        }),
      );
  }

  private getActionName(action: EITransactionInstanceModel): string {
    if (TranslatedActionTypes.includes(action.type)) {
      return this.translate.instant(`activity.actionNames.${action.type}`);
    }
    return action.transitionName || action.actionName;
  }
}
